<div class="search-sessions">
    <div class="search-sessions__title">Диалоги</div>
    <chat-session-list
        [sessions]="sessions"
        [showAvatar]="true"
        [createLabel]="null"
        (sessionSelected)="sessionSelected.emit($event)"
    ></chat-session-list>
</div>
